/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from "utils/styles/style_helpers";



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default theme =>({
    paymentinfo: {
    	'& .variant-withctas': {
    		'& .button': {
    			minWidth: pxToEm(149),
                width: 'auto',
                padding: pxToEm(10),
    			'&:last-child': {
    				marginLeft: pxToEm(10)
    			}
    		}
    	}
    }
});